// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js","948":"2cca2479","976":"c16184b3"}[chunkId] + "-" + {"351":"fc06883905e7543fea72","678":"f85fdb4e4908fc52ede7","883":"8764ec2916928db4e083","948":"a61e872c90468716d205","976":"f8f1357de35e8f1ddd13"}[chunkId] + ".js";
};